"use strict";

var _slicedToArray = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * A `NumberScheduler` returns some numeric value that changes over time according to a sequence of
 * interpolation functions.
 */

var NumberScheduler =
/*#__PURE__*/
function () {
  function NumberScheduler() {
    var defaultValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    _classCallCheck(this, NumberScheduler);

    this._interpolators = [];
    this._end = 0;
    this._defaultValue = defaultValue;
  }
  /**
   * Appends an interpolation trajectory from current end *to* timestep `t`, i.e. `[end, t)`.
   * @param t
   * @param fn
   */


  _createClass(NumberScheduler, [{
    key: "to",
    value: function to(t, fn) {
      if (t <= this._end) throw Error("Already set in range [0, ".concat(this._end, "); got t = ").concat(t));

      this._interpolators.push([this._end, t, fn]);

      this._end = t;
      return this;
    }
    /**
     * Appends an interpolation trajectory from current end *for* `deltat` timesteps, i.e.
     * `[end, end + deltat)`.
     * @param deltat
     * @param fn
     */

  }, {
    key: "for",
    value: function _for(deltat, fn) {
      if (deltat < 1) throw Error("New range must be positive; got deltat = ".concat(deltat));

      this._interpolators.push([this._end, this._end + deltat, fn]);

      this._end += deltat;
      return this;
    }
    /**
     * Returns value at the specified timestep `t`.
     * @param t
     */

  }, {
    key: "get",
    value: function get(t) {
      if (t < 0 || this._end <= t) return this._defaultValue;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this._interpolators[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref3 = _step.value;

          var _ref2 = _slicedToArray(_ref3, 3);

          var start = _ref2[0];
          var end = _ref2[1];
          var fn = _ref2[2];

          if (start <= t && t < end) {
            return fn((t - start) / (end - start));
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return this._defaultValue;
    }
  }]);

  return NumberScheduler;
}();

exports.NumberScheduler = NumberScheduler;
/**
 * Constant `value` throughout the range.
 * @param value
 */

function constant(value) {
  return function (u) {
    return value;
  };
}

exports.constant = constant;
/**
 * Linearly interpolates from `start` to `end`.
 * @param start
 * @param end
 */

function linear(start, end) {
  return function (u) {
    return (end - start) * u + start;
  };
}

exports.linear = linear;
/**
 * Exponentially interpolates from `start` to `end`, with different curvature.
 * @param start
 * @param end
 * @param curvature
 *     Positive is concave up, while negative is concave down. Magnitude controls the steepness of
 *     the ascent/descent.
 */

function exponential(start, end) {
  var curvature = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  // For numerical stability, use linear when have small curvature.
  if (Math.abs(curvature) < 0.1) return linear(start, end);

  if (start <= end) {
    return function (u) {
      return (Math.pow(2, curvature * u) - 1) / (Math.pow(2, curvature) - 1) * (end - start) + start;
    };
  } else {
    return function (u) {
      return (Math.pow(2, curvature * (1 - u)) - 1) / (Math.pow(2, curvature) - 1) * (start - end) + end;
    };
  }
}

exports.exponential = exponential;
/**
 * A `BooleanScheduler` returns some boolean value that changes over time according to a sequence of
 * active ranges.
 */

var BooleanScheduler =
/*#__PURE__*/
function () {
  function BooleanScheduler() {
    var defaultValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    _classCallCheck(this, BooleanScheduler);

    this._values = [];
    this._end = 0;
    this._defaultValue = defaultValue;
  }
  /**
   * Appends an value from current end *to* timestep `t`, i.e. `[end, t)`.
   * @param t
   * @param value
   */


  _createClass(BooleanScheduler, [{
    key: "to",
    value: function to(t, value) {
      if (t <= this._end) throw Error("Already set in range [0, ".concat(this._end, "); got t = ").concat(t));

      this._values.push([this._end, t, value]);

      this._end = t;
      return this;
    }
    /**
     * Appends an interpolation trajectory from current end *for* `deltat` timesteps, i.e.
     * `[end, end + deltat)`.
     * @param deltat
     * @param value
     */

  }, {
    key: "for",
    value: function _for(deltat, value) {
      if (deltat < 1) throw Error("New range must be positive; got deltat = ".concat(deltat));

      this._values.push([this._end, this._end + deltat, value]);

      this._end += deltat;
      return this;
    }
    /**
     * Returns value at the specified timestep `t`.
     * @param t
     */

  }, {
    key: "get",
    value: function get(t) {
      if (t < 0 || this._end <= t) return this._defaultValue;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this._values[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _ref6 = _step2.value;

          var _ref5 = _slicedToArray(_ref6, 3);

          var start = _ref5[0];
          var end = _ref5[1];
          var value = _ref5[2];

          if (start <= t && t < end) {
            return value;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return this._defaultValue;
    }
  }]);

  return BooleanScheduler;
}();

exports.BooleanScheduler = BooleanScheduler;